export default __webpack_public_path__ + "static/media/l23.c7304169.png";